export default {
	install: (Vue, options) => {
		// Get browser locale with fallback to nl-BE
		const locale = (typeof navigator !== 'undefined' && navigator.language) || 'nl-BE';

		Vue.prototype.$formatter = {
			toCurrency: function(value: number, currency) {
				if (value === undefined || value === null) {
					value = 0;
				}
				if (isNaN(value)) {
					return 'NaN';
				}
				const currencyCode = currency || 'EUR';
				return new Intl.NumberFormat(locale, {
					style: 'currency',
					currency: currencyCode,
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(value);
			},
			toCurrencySymbol: function(currency) {
				const currencyCode = currency || 'EUR';
				const parts = new Intl.NumberFormat(locale, {
					style: 'currency',
					currency: currencyCode,
					minimumFractionDigits: 0,
					maximumFractionDigits: 0
				}).formatToParts(0);

				const symbolPart = parts.find((p) => p.type === 'currency');
				return symbolPart ? symbolPart.value : currencyCode;
			}
		};
	}
};
